<template>
  <oxd-layout v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
    <template #user-actions>
      <li>
        <a
          href="#"
          role="menuitem"
          class="oxd-userdropdown-link"
          @click="openAboutModel"
        >
          {{ $t('general.about') }}
        </a>
      </li>
      <li v-if="updatePasswordUrl">
        <a
          :href="updatePasswordUrl"
          role="menuitem"
          class="oxd-userdropdown-link"
        >
          {{ $t('general.change_password') }}
        </a>
      </li>
      <li>
        <a :href="logoutUrl" role="menuitem" class="oxd-userdropdown-link">
          {{ $t('general.logout') }}
        </a>
      </li>
    </template>
  </oxd-layout>
  <about v-if="showAboutModel" @close="closeAboutModel"></about>
</template>

<script>
import {
  provide,
  readonly,
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from 'vue';
import About from '@/core/pages/About.vue';
import {OxdLayout} from '@ohrm/oxd';
import {dateFormatKey} from '@/core/util/composable/useDateFormat';
import {syncHideTopbarBodyClass} from '@/core/util/hideTopbarBodyPages';
import fetchBuzzUnreadCount from '@/orangehrmBuzzPlugin/util/fetchBuzzUnreadCount';
import {
  subscribeBuzzUnreadCount,
  updateBuzzSideMenuBadge,
} from '@/orangehrmBuzzPlugin/util/buzzUnreadCount';

export default {
  components: {
    about: About,
    'oxd-layout': OxdLayout,
  },
  inheritAttrs: false,
  props: {
    permissions: {
      type: Object,
      default: () => ({}),
    },
    logoutUrl: {
      type: String,
      default: '#',
    },
    updatePasswordUrl: {
      type: String,
      default: '#',
    },
    dateFormat: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const showAboutModel = ref(false);
    const buzzUnreadCount = ref(0);
    provide('permissions', readonly(props.permissions));
    provide(dateFormatKey, readonly(props.dateFormat));

    let unsubscribeBuzzUnreadCount = null;
    let menuObserver = null;

    const syncBuzzSideMenuBadge = (count) => {
      buzzUnreadCount.value = count;
      nextTick(() => updateBuzzSideMenuBadge(count));
    };

    const openAboutModel = () => {
      showAboutModel.value = true;
    };

    const closeAboutModel = () => {
      showAboutModel.value = false;
    };

    onMounted(() => {
      syncHideTopbarBodyClass();
      fetchBuzzUnreadCount().then(syncBuzzSideMenuBadge);
      unsubscribeBuzzUnreadCount = subscribeBuzzUnreadCount(
        syncBuzzSideMenuBadge,
      );

      const menuRoot = document.querySelector('.oxd-main-menu');
      if (menuRoot) {
        menuObserver = new MutationObserver(() => {
          updateBuzzSideMenuBadge(buzzUnreadCount.value);
        });
        menuObserver.observe(menuRoot, {childList: true, subtree: true});
      }
    });

    onBeforeUnmount(() => {
      unsubscribeBuzzUnreadCount?.();
      menuObserver?.disconnect();
    });

    return {
      showAboutModel,
      openAboutModel,
      closeAboutModel,
    };
  },
};
</script>

<style src="./layout-buzz-menu-badge.scss" lang="scss"></style>
